var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.226 2.21525C20.46 2.54867 19.6476 2.76764 18.8158 2.86492C19.6919 2.34867 20.3473 1.53669 20.6601 0.580212C19.8373 1.06203 18.9352 1.3997 17.996 1.58236C17.3645 0.917467 16.5274 0.476505 15.6149 0.32803C14.7024 0.179556 13.7656 0.331887 12.9502 0.761343C12.1347 1.1908 11.4863 1.87332 11.1057 2.70279C10.7252 3.53226 10.6338 4.46222 10.8457 5.34808C9.177 5.26592 7.54448 4.83933 6.05418 4.09599C4.56389 3.35266 3.24915 2.30921 2.19533 1.0334C1.82235 1.66377 1.62635 2.38036 1.62739 3.10978C1.62739 4.54142 2.36892 5.8062 3.49374 6.54671C2.82749 6.52603 2.17591 6.34899 1.59328 6.03033V6.08068C1.59325 7.03433 1.92845 7.95863 2.54204 8.69681C3.15562 9.43499 4.00981 9.94162 4.95972 10.1308C4.34126 10.2958 3.69271 10.3202 3.06328 10.2018C3.33111 11.0227 3.85317 11.7406 4.55635 12.2549C5.25952 12.7692 6.10859 13.0543 6.98461 13.0701C6.114 13.7429 5.11715 14.2402 4.05104 14.5337C2.98494 14.8271 1.87051 14.9108 0.771484 14.7801C2.68973 15.994 4.9227 16.6384 7.20335 16.6363C14.9236 16.6363 19.1439 10.344 19.1439 4.88699C19.1439 4.70927 19.1399 4.52957 19.1319 4.35284C19.9531 3.76869 20.6619 3.04517 21.225 2.21623L21.226 2.21525Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.1688670ac2a8f868ce525c65e70be8c9.svg";
export { ForwardRef as ReactComponent };